module.exports = __webpack_public_path__ + "ce2303b97a552d321794dcc8d2d51826.png";